import React, {ReactNode} from "react";
import '../../styles/components/lesson/control-bar-button.scss';

interface IControlBarButtonProps {
  onClick: (ev: React.MouseEvent) => void;
  onTouchStart?: () => void;
  onMouseDown?: () => void;
  text?: string;
  tooltip?: string;
  ariaLabel?: string;
  disabled?: boolean;
  className?: string;
  toggledOn?: boolean;
  children?: ReactNode;
}

export default function ControlBarButton({onClick, disabled, text, ariaLabel, tooltip, className, toggledOn, children, onMouseDown, onTouchStart}: IControlBarButtonProps) {
  const toggledOnClassName = toggledOn ? `toggled-on` : "";
  const disabledClassName = disabled ? "disabled" : "";
  return (
    <button
      className={`${className} ${toggledOnClassName} ${disabledClassName}`}
      title={tooltip}
      aria-label={ariaLabel}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onClick={(ev: React.MouseEvent)=> {if(!disabled){onClick(ev)}}} >{text}{children}
    </button>
  );
}